
import Vue from "vue";
const states = ["none", "init", "left-win", "right-win"] as const;
export type CharacterState = typeof states[number];

export default Vue.extend({
  name: "CharacterView",
  computed: {
    shows: function () {
      return this.state !== "none";
    },
    leftClass: function () {
      return {
        "left-win": this.state === "left-win",
      };
    },
    rightClass: function () {
      return {
        "right-win": this.state === "right-win",
      };
    },
  },
  props: ["state", "left", "right"],
});
